/**
 * Created by Christal on 2018/5/14.
 */

export default {
  changeToken (ctx, token) {
    ctx.commit('changeToken', token)
  },
  changeUsername (ctx, username) {
    ctx.commit('changeUsername', username)
  },
  changePassword (ctx, password) {
    ctx.commit('changePassword', password)
  },
  changeRole (ctx, role) {
    ctx.commit('changeRole', role)
  },
  changeEmployer (ctx, employer) {
    ctx.commit('changeEmployer', employer)
  },
}



// WEBPACK FOOTER //
// ./src/store/actions.js